export interface ChangeFilter<T> {
  accept(value: T | undefined): boolean;
  reset(): void;
}

export function createChangeFilter<T>(): ChangeFilter<T> {
  let baseline: T | undefined;

  return {
    accept(value) {
      if (value === undefined) return false;
      if (baseline === undefined) {
        baseline = value;
        return false;
      }
      if (Object.is(value, baseline)) return false;

      baseline = value;
      return true;
    },
    reset() {
      baseline = undefined;
    },
  };
}
